export const SESSIONS_STEP_PLANNING = 'planning'
export const SESSIONS_STEP_PRICING = 'pricing'
export const SESSIONS_STEP_CONFIRMATION = 'confirmation'

export const SESSIONS_STEPS_LIST = [
  SESSIONS_STEP_PLANNING,
  SESSIONS_STEP_PRICING,
  SESSIONS_STEP_CONFIRMATION,
]

export const SESSIONS_ACTIVE_DEPENDENCIES = {
  [SESSIONS_STEP_PLANNING]: [],
  [SESSIONS_STEP_PRICING]: [SESSIONS_STEP_PLANNING],
  [SESSIONS_STEP_CONFIRMATION]: [SESSIONS_STEP_PLANNING, SESSIONS_STEP_PRICING],
}

export const SESSIONS_STEP_ACTIVE = 'active'
export const SESSIONS_STEP_DISABLED = 'disabled'
export const SESSIONS_STEP_OPEN = 'open'
export const SESSIONS_STEP_COMPLETED_WITH_ERRORS = 'errors'
export const SESSIONS_STEP_COMPLETED = 'completed'

export const GROUPS_TOTAL = 10

export const getCurrentStepIndex = (currentState) =>
  SESSIONS_STEPS_LIST.findIndex((state) => state === currentState)

export const getNextStep = (currentState) =>
  SESSIONS_STEPS_LIST[getCurrentStepIndex(currentState) + 1]

export const getLastSessionState = (steps) =>
  steps.find(
    (step) =>
      step.state === SESSIONS_STEP_OPEN ||
      step.state === SESSIONS_STEP_COMPLETED_WITH_ERRORS
  )?.step || SESSIONS_STEP_CONFIRMATION

export const checkAssignment = (session) => !!session?.assignmentStartedAt

export const isStepDisabled = (session, step) =>
  SESSIONS_ACTIVE_DEPENDENCIES[step].length &&
  SESSIONS_ACTIVE_DEPENDENCIES[step].some((el) => !session[`${el}AcceptedAt`])

export const getSessionsStepUrl = (sessionId, step) =>
  `/sessions/${sessionId}/${step}`
